import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-640a4f7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topic-insights" }
const _hoisted_2 = { class: "topic-insights-header" }
const _hoisted_3 = { class: "smileys" }
const _hoisted_4 = { key: 0 }

import { computed, type ComputedRef } from 'vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import {
    faLightbulbOn,
    faFaceFrownSlight,
} from 'fontawesome/pro-regular-svg-icons'
import { faFaceSmile } from 'fontawesome/free-regular-svg-icons'
import { Topic } from '@/entities/huddles'
import Typography from '@/components/Rain/Typography/Typography.vue'
import HuddlesTopicChart from '@/mobile/src/views/appV4/huddles/HuddlesTopicsChart.vue'

interface Props {
    topics: Topic[]
    baseCxscoreGoal: number | undefined
    summaryView: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddleDetailsTopicsPanel',
  props: {
    topics: {},
    baseCxscoreGoal: {},
    summaryView: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const getCxScoreDifference = (cxscore: number, cxscoreGoal: number) => {
    return Math.abs(Math.abs(cxscore) - cxscoreGoal)
}
const topicsWithLargestCxScoreDifference: ComputedRef<Topic[]> = computed(
    () => {
        return [...props.topics]
            .sort((a, b) => {
                const aDifference = getCxScoreDifference(
                    a.cxscore,
                    props.baseCxscoreGoal
                )
                const bDifference = getCxScoreDifference(
                    b.cxscore,
                    props.baseCxscoreGoal
                )
                return aDifference > bDifference ? -1 : 1
            })
            .splice(0, 3)
    }
)

const getSmileyIcon = (cxscore: number) => {
    return cxscore > props.baseCxscoreGoal ? faFaceSmile : faFaceFrownSlight
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(FontAwesomeIcon), {
        icon: _unref(faLightbulbOn),
        size: "lg"
      }, null, 8, ["icon"]),
      _createVNode(Typography, { variant: "subtitle1" }, {
        default: _withCtx(() => [
          _createTextVNode("Insights")
        ], undefined, true),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topicsWithLargestCxScoreDifference.value, (topic, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "topic-smiley"
        }, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: getSmileyIcon(topic.cxscore),
            class: _normalizeClass(`smiley-icon--${topic.cxscore > _ctx.baseCxscoreGoal ? 'smile' : 'frown'}`),
            size: "xl"
          }, null, 8, ["icon", "class"]),
          _createVNode(Typography, {
            variant: "body2",
            class: "topic-name"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(topic.topic), 1)
            ], undefined, true),
            _: 2
          }, 1024)
        ]))
      }), 128))
    ]),
    (!_ctx.summaryView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(HuddlesTopicChart, {
            topics: _ctx.topics,
            "base-cxscore-goal": _ctx.baseCxscoreGoal
          }, null, 8, ["topics", "base-cxscore-goal"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})